// 行业知识点
import React, { Component } from 'react'

import { Rate } from 'antd';
import { StarFilled } from "@ant-design/icons";

import WidgetAjax from '../widget/WidgetAjax';
import Config from '../config/Config';

import '../css/panorama.css'
import "../css/EntityKnowledge.css"

class EntityKnowledge extends Component {
    constructor( props )
    {
        super(props);

        this.state = {
            basePath:Config.getBasePath(),
            ENTNAME:props.ENTNAME,
            INDUSTRY:props.INDUSTRY,
            data:[]
        }

        this.loadEntityBusinessSchema = this.loadEntityBusinessSchema.bind(this);
        this.onLoadEntityBusinessSchema = this.onLoadEntityBusinessSchema.bind(this);
    }

    componentDidMount()
    {
        this.loadEntityBusinessSchema();
    }

    loadEntityBusinessSchema()
    {
        const {ENTNAME, INDUSTRY, basePath} = this.state;

        if( ENTNAME!==undefined && ENTNAME!==null && ENTNAME!=="" )
        {
            let params = {
                ENTNAME:ENTNAME,
                INDUSTRY:INDUSTRY,
            };
    
            WidgetAjax.ajax({ url: basePath + '/entity/business_schema', params: params, callback: this.onLoadEntityBusinessSchema });
        }
    }

    onLoadEntityBusinessSchema(result, params )
    {
        if( result.status===0 )
        {
            for(let i in result.results){
                let item = result.results[i]
                for(let j=2;j<=3;j++){
                    item.description = item.description.replace(`${j}.`, `<br/>${j}.`)
                }
            }
            this.setState({data:result.results})
        }
        else if ( result.status===10 ) 
        {
            Cache.logout(this.props.parentProps);
        }
    }

    componentWillReceiveProps(nextProps)
    {
        let { ENTNAME, INDUSTRY } = this.state;

        if( nextProps.ENTNAME!==ENTNAME || nextProps.INDUSTRY!==INDUSTRY )
        {
            this.state["ENTNAME"] = nextProps.ENTNAME;
            this.state["INDUSTRY"] = nextProps.INDUSTRY;
            
            this.loadEntityBusinessSchema();
        }
    }

    render() 
    {
        const { data } = this.state;

        if( data.length===0 )  //无数据
        {
            return (
                <div className="page entityKnowledge">
                     <div >
                            <div className='titles'>中小企业</div>

                            <div className="header">
                            <div className="headerLeft"><img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get" /><span>获客难度：</span><Rate disabled defaultValue={'2'} /></div>
                            <div className="headerRight"><img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img><span>存款预估：</span><span className="money">在200万元以上</span></div>
                        </div>

                        <div className="footers">
                            <div style={{borderBottom:"1px solid #cccccc"}}>
                                <p style={{textAlign:"left",marginBottom:"10px"}}><img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img><span>获客方案:</span></p>
                                    <ul>
                                        <li>
                                        1.流动资金贷款:通过银行为中小企业提供流动资金贷款等,要求企业将结算存款配套存放在银行,通过吸引企业做流水方式,银行获取低成本的存款沉淀;<br/>
                                        2.法人账户透支:银行通过为中小企业办理法人账户透支业务,法人账户透支可以天然促进小企业将结算存款大量回流透支银行,降低贷款利息基数,从而降低成本支出;<br/>
                                        3.小面额银行承兑汇票:根据小企业的零星采购支出,银行开业办理小面额银行承兑汇票,比如5万元、33万元的银行承兑汇票,可以促进存款增加。<br/>
                                        </li>
                                    </ul>
                            </div>

                            <div>
                                <p style={{textAlign:"left",marginBottom:"10px"}}><img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img><span>获客技巧:</span></p>
                                    <ul>
                                        <li style={{textIndent:'20px'}}>
                                        中小企业普遍缺少银行的信贷扶持,银行通过提供流动资金贷款,可以大幅获得存款回报。银行可以将企业在银行的结算进行考核,要求借款企业在银行大量做结算流水,并按照流水情况,给予一定的贷款利率优惠。秉持的观点：企业在银行贷款,必须在这家银行办理结算,而且结算必须与贷款金额挂钩,否则,很多借款企业都是在小银行贷款,在工行、农行、中行、建行等大银行办理结算,会使小银行承担信贷风险,大银行获得结算收益。银行对裸贷客户进行逐户分析,对重点治理的裸贷客户明确落实了责任人。在当前企业普遍资金紧张,提高日均存贷比较困难的情况下,高度重视并突出加大时点存贷比的提升力度,确保时点存贷比不低于33%,逐步摆脱裸贷现象。加强销售收入归行管理,确保进一步提高信贷资金支付留存率和有贷户存贷比水平,有效促进公司存款增长。加强现金管理等结算类产品的营销拓展,提高客户产品渗透率,提高客户黏性,通过客户结算流水沉淀存款。
                                        </li>
                                    </ul>
                            </div>
                        </div>
                    </div>

                    <div style={{width:"100%",height:"0.5px",background:"#cccccc"}}></div>
                </div>
            )
        }
        else
        {
            return (
                <div className="page entityKnowledge">
                {
                    data.map((item, index) => {
                        return (
                            <>
                            <div key={index}>
                                 <div className='titles'>{item.name}</div>
    
                                 <div className="header">
                                    <div className="headerLeft"><img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get" /><span>获客难度：</span><Rate disabled defaultValue={item.level} /></div>
                                    <div className="headerRight"><img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img><span>存款预估：</span><span className="money">{item.deposit}</span></div>
                                </div>
    
                                <div className="footers">
                                    <div style={{borderBottom:"1px solid #cccccc"}}>
                                        <p style={{textAlign:"left",marginBottom:"10px"}}><img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img><span>获客方案:</span></p>
                                            <ul>
                                               <li dangerouslySetInnerHTML={{__html: item.description}}></li>
                                            </ul>
                                    </div>
    
                                    <div>
                                        <p style={{textAlign:"left",marginBottom:"10px"}}><img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img><span>获客技巧:</span></p>
                                            <ul>
                                                <li style={{textIndent:'20px'}}>{item.disposition}</li>
                                            </ul>
                                    </div>
                                </div>
                            </div>
    
                            <div style={{width:"100%",height:"0.5px",background:"#cccccc"}}></div>
                            </>
                        )                    
                    })
                }
                </div>
            )
        }
        
    }
}

// let StarFilledX = ( num )=>{
//     if(num === 0)
//     {
//         return null;
//     }
//     else
//     {
//         switch(num)
//         {
//             case 1:
//             return  <div>
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                     </div>
//             break;
//             case 2:
//             return  <div>
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                     </div>
//             break;
//             case 3:
//             return  <div>
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                     </div>
//             break;
//             case 4:
//             return  <div>
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                     </div>
//             break;
//             case 5:
//             return  <div>
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                         <StarFilled style={{color:"#C0C053"}} className='difficultyStar' />
//                     </div>
//             break;
//             default:
//             break;
//         }
//     }
// }

export default EntityKnowledge